export const formatMessage = (template: string, args: string[]): string =>
  args.reduce(
    (msg, arg, index) => msg.replace(`{${index}}`, arg !== undefined ? arg : ''),
    template,
  );
